import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CLIENTS } from '@/constants/clients';
import { forwardRef } from 'react';
import type { Ref } from 'react';

interface LandingClientsProps {
  content: {
    title: string;
    description: string;
  };
  background?: 'grey' | 'white';
  ref?: Ref<HTMLElement>;
}

const LandingClients = forwardRef<HTMLElement, LandingClientsProps>(({ content, background = 'grey' }, ref) => {
  return (
    <section ref={ref} id='clients' className={`w-full py-[42px] ${background === 'grey' ? 'bg-[#fafafa]' : ''}`}>
      <div className='px-4 mx-auto md:container '>
        <h2 className='text-center font-extrabold m-0 mb-[5px]' dangerouslySetInnerHTML={{ __html: content.title }} />

        <p className='text-[#525252] tracking-tight text-[1.125rem]/[1.35rem] font-regular text-center max-w-[80%] mx-auto'>
          {content.description}
        </p>
      </div>

      <Swiper
        autoplay
        modules={[Autoplay]}
        slidesPerView='auto'
        slidesOffsetAfter={0}
        className='mt-4 pb-1 px-4 [&>div]:items-center'
        centeredSlidesBounds
      >
        {CLIENTS.map((client, index) => (
          <SwiperSlide key={index} className='flex w-[max-content] items-center justify-center mt-4'>
            <img src={client.logo} alt={client.name} className='px-3 h-[34px] md:h-[42px] w-auto color-logo-to-grey' />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
});

LandingClients.displayName = 'LandingClients';

export default LandingClients;
